// extracted by mini-css-extract-plugin
export default {"moreButton":"_2V-Tp","openButton":"_11OI0","arrow":"kjfgI","arrowUp":"_1Rjxp","actionText":"e6xqg","preLabel":"_157ir"};